import { Base } from "../../framework/base";
import { FileAttachment, IFileAttachment } from "../common/fileAttachment";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IEventEditItemMessage {
    id: string;
    date: number;
    content: string;
    myMessage: boolean;
    allRead: boolean;
    isRead: boolean;
    modifyUser: IModifyUser;
    attachments: IFileAttachment[];

    uiType: number;
}

export class EventEditItemMessage implements IEventEditItemMessage {
    id: string;
    date: number;
    content: string;
    myMessage: boolean;
    allRead: boolean;
    isRead: boolean;
    modifyUser: IModifyUser;
    attachments: FileAttachment[];

    uiType: number;

    constructor();
    constructor(obj: IEventEditItemMessage);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.date = obj && obj.date || 0;
        this.content = obj && obj.content || "";
        this.myMessage = obj && obj.myMessage || false;
        this.allRead = obj && obj.allRead || false;
        this.isRead = obj && obj.isRead || false;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.attachments = Base.getTypedArray<FileAttachment>(obj ? obj.attachments : null, FileAttachment);
        this.uiType = obj && obj.uiType || 0;
    }
        
    static sortEventEditItemMessages(items: IEventEditItemMessage[]): IEventEditItemMessage[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IEventEditItemMessage, b: IEventEditItemMessage) => { return (!a || !b) ? 0 : Base.numCompare(a.modifyUser.date, b.modifyUser.date); });
    }
}